import { createFileRoute } from '@tanstack/react-router';
import { ByProjectView } from '@/features/timesheet/ByProjectView';

export const Route = createFileRoute('/_app/timesheet/by-project')({ component: ByProjectView });
